import React from "react";
import { Link } from "react-router-dom";

export default function MobileCTA() {
  return (
    <Link
      to="/contact"
      data-testid="mobile-cta"
      className="fixed bottom-0 left-0 z-[60] w-full bg-[var(--gold)] py-4 text-center text-xs font-semibold uppercase tracking-[0.25em] text-black md:hidden"
    >
      Start a Conversation
    </Link>
  );
}
